module.exports = __webpack_public_path__ + "img/btnBtnEventUninitiated.a40aca8d.png";